module.exports = __webpack_public_path__ + "img/file--------40@1x.02d0dbee.png";